import { Flex } from '@chakra-ui/react';
import React from 'react';

import { CaseContextBar } from '../../molecules/CaseContextBar';
import { PatientSummaryBar } from '../../molecules/PatientSummaryBar';
import { TopBarContainer } from '../../molecules/TopBarContainer';

/**
 * Header organism -- composes the three header bars into a vertical stack, in the fixed DOM order:
 * `TopBarContainer`, `PatientSummaryBar`, `CaseContextBar`. Pure composition, no data logic of its
 * own -- each molecule independently reads its own config slice via `useCodingConfig()`, so
 * `HeaderBar` itself takes no props and reads no context.
 */
export const HeaderBar: React.FC = () => (
  <Flex direction="column">
    <TopBarContainer />
    <PatientSummaryBar />
    <CaseContextBar />
  </Flex>
);
